module.exports = "/_next/static/images/introSectionCard1-e4a7263941795433f9e75b53d5a23911.png";